var map = {
	"./0_0-1.jpeg": 42804,
	"./3dots.svg": 22281,
	"./Chevron left.svg": 92158,
	"./Chevrons right.svg": 38472,
	"./Clock.svg": 51016,
	"./Dollar sign.svg": 47927,
	"./Drug Development.png": 65487,
	"./Drugomics banner video-small.mp4": 36339,
	"./Fibrosis1.png": 10314,
	"./Fibrosis2.png": 59297,
	"./Fibrosis3.png": 74680,
	"./Fibrosis4-1.png": 94705,
	"./Fibrosis4-2.png": 18458,
	"./Fibrosis4.png": 66199,
	"./HE.png": 10095,
	"./HE1.png": 85334,
	"./HE2.png": 66957,
	"./HE3.png": 27012,
	"./HE4.png": 8667,
	"./OA1.png": 66013,
	"./OA2.png": 24774,
	"./OA3-1.png": 82905,
	"./OA3-2.png": 43170,
	"./OA3.png": 63791,
	"./OA4-1.png": 43438,
	"./OA4-2.png": 62213,
	"./OA4.png": 20944,
	"./OA5.png": 17849,
	"./Pie chart.svg": 1836,
	"./SFO.png": 23614,
	"./SFO1.png": 25189,
	"./SFO2.png": 53390,
	"./SFO3.png": 96407,
	"./SFO4.png": 4888,
	"./Vaccine development.png": 32722,
	"./biomedical-engineer.jpg": 83547,
	"./biomedical-student-working.jpg": 24553,
	"./busy-chef-preparing.jpg": 49707,
	"./dna-robot-hand.jpg": 84340,
	"./doctor-from-future.jpg": 77948,
	"./drug-design-base.png": 79087,
	"./drug-design-pill.png": 2321,
	"./drug-illustration.png": 94337,
	"./drug_1.png": 24020,
	"./drugomics.jpg": 60457,
	"./focused-female-scientist.jpg": 5191,
	"./male-pharmacist.jpg": 39450,
	"./medicine-base.png": 66550,
	"./medicine-helix.png": 87441,
	"./medicine-illustration.png": 86019,
	"./medicine_making.jpg": 78532,
	"./mission.svg": 48296,
	"./partnership.svg": 36678,
	"./personalized medicine.png": 24814,
	"./pill-shiny.jpg": 86513,
	"./portrait-women-lab.jpg": 16928,
	"./rocket.svg": 27690,
	"./shakehand.svg": 24379,
	"./solutions.svg": 32470,
	"./vaccine-design-base.png": 46006,
	"./vaccine-design-syringe.png": 20450,
	"./vaccine-illustration.png": 28030,
	"./vaccine_1.jpg": 72545,
	"./women-lab-coat.jpeg": 62655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50448;